import "../heading.css"
export default function HeadingSection() {
    return (
        <div className="main-heading-wrapper">
            <div className="heading-fade">
                <h1>Your Videos. Podcasts. Newsletters. Photos. Paid Products. Streams. Calendar.</h1>
                <div className="fade-effect"></div>
            </div>
            <h2 className="headingsmall">
                All your content integrated into your personal page.
            </h2>
        </div>
    )
}